import { IDeviceInfo } from '../info/types';
import request from '../request';
import { encodeBody } from './encode';
import { uuid } from '@roai/shared';
import { ICommonInfo } from '../info/common';
import { reportError } from '../monitor';

let preRequestId: Nullable<string> = null;

export async function send(
  url: string,
  data: {
    deviceInfo: Nullable<IDeviceInfo>;
    commonInfo: ICommonInfo;
    params: Record<string, string>;
    eventData: {
      eventId: string;
      preEventId: string;
      eventType: string;
    } & Record<string, string>;
  }
): Promise<{
    success: boolean;
    type?: 'server' | 'internal';
    detail?: Error;
    code?: number;
    message?: string;
  }> {
  const requestId = uuid();
  try {
    const encodedBody = await encodeBody({
      deviceInfo: data.deviceInfo as IDeviceInfo,
      params: data.params,
      preRequestId,
      requestId,
      eventData: data.eventData,
      commonInfo: data.commonInfo,
    });

    reportError({
      logType: 'analytics',
      logName: 'send.before-' + data.eventData.eventType,
      bizType: 'carty-ad-creative',
      params: {} 
    })

    if (navigator && typeof navigator === 'object' && typeof navigator.sendBeacon === 'function') {
      // eslint-disable-next-line
      const res = navigator.sendBeacon(url, encodedBody as any);
      reportError({
        logType: 'analytics',
        logName: 'send.success-' + data.eventData.eventType,
        bizType: 'carty-ad-creative',
        params: {} 
      })

      return {
        success: res,
      }
    } else {
      const res = await request.send(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-protobuf',
          'Accept': 'application/json',
          'Content-Encoding': 'gzip',
        },
        body: encodedBody,
      });

      const json = await res.data.json();

      reportError({
        logType: 'analytics',
        logName: 'send.success-' + data.eventData.eventType,
        bizType: 'carty-ad-creative',
        params: {} 
      })

      if (json.code === 0) {
        return {
          success: true,
        }
      } else {
        return {
          success: false,
          type: 'server',
          code: json.code,
          message: json.message,
        }
      }
    }
  } catch (error: unknown) {
    reportError({
      logType: 'error',
      logName: 'send.error',
      bizType: 'carty-ad-creative',
      params: {
        track: (error as Error).stack || (error as Error).message || '',
      },
    })
    return {
      success: false,
      type: 'internal',
      detail: error as Error
    };
  } finally {
    preRequestId = requestId;
  }
}
